import React, { useState, useRef, useEffect } from 'react'
import { Tooltip } from '@material-ui/core'
import PropTypes from 'prop-types'
import SydSelect from '../../../commonDesign/SydSelect'
import SydButton from '../../../commonDesign/Button'

const GroupConfigurationContent = ({ maxGroupings, availableGroupings, activeGroups, defaultGroups, onGroupSave, onCancel }) => {
  const [activeGroupings, setActiveGroupings] = useState(
    activeGroups?.length ? activeGroups : defaultGroups?.length ? defaultGroups : []
  )
  const resetGroupings = () => {
    setActiveGroupings(defaultGroups?.length ? defaultGroups : [])
  }
  const containerRef = useRef(null)
  const maxGroupNumber = availableGroupings.length < maxGroupings ? availableGroupings.length : maxGroupings
  useEffect(() => {
  }, [activeGroupings, defaultGroups])
  const removeGrouping = (index) => {
    // Don't allow removing the first level (HouseHold)
    if (index === 0) return

    const newGroupings = activeGroupings.filter((_, i) => i !== index)
    setActiveGroupings(newGroupings)
  }

  const addGrouping = (nextGrouping) => {
    if (nextGrouping) {
      const newGroupings = [...activeGroupings, nextGrouping]
      setActiveGroupings(newGroupings)
    }
  }

  const getAvailableGroupingsForAdd = () => {
    return availableGroupings.filter(g => !activeGroupings.includes(g))
  }

  const getAvailableGroupingsForPosition = (currentIndex) => {
    // Get all unused groupings plus the current one at this position
    const unused = availableGroupings.filter(g => !activeGroupings.includes(g))
    const current = activeGroupings[currentIndex]
    return [...unused, current]
  }

  const updateGrouping = (index, newGrouping) => {
    const newActiveGroupings = [...activeGroupings]
    newActiveGroupings[index] = newGrouping
    setActiveGroupings(newActiveGroupings)
  }

  return (
    <div className='flex flex-col justify-between gap-2 flex-1'>
      <div ref={containerRef} className='flex flex-col justify-start items-start gap-2'>
        {activeGroupings.map((grouping, index) => (
          <div key={index} className='flex items-center gap-2 w-full'>
            <div className='flex-1'>
              <SydSelect size='sm' value={grouping} options={getAvailableGroupingsForPosition(index)} onChange={(e) => updateGrouping(index, e.target.value)} />
            </div>
            {index > 0 && (
              <SydButton
                onClick={() => removeGrouping(index)}
                className='flex-none w-10'
                priority='warning'
                variant='outline'
                size='xs'
                icon='subtract'
              >
                Remove
              </SydButton>
            )}
          </div>
        ))}
        {getAvailableGroupingsForAdd().length > 0 && (
          <div className='flex justify-start w-full mt-1'>
            {activeGroupings.length >= maxGroupNumber ? (
              <Tooltip title='Max Number of Groupings' placement='top'>
                <span>
                  <SydButton
                    disabled
                    className='bg-primary-main text-white'
                    priority='main'
                    variant='outline'
                    size='md'
                    icon='add'
                  >
                    Add grouping
                  </SydButton>
                </span>
              </Tooltip>
            ) : (
              <SydButton
                onClick={() => addGrouping(getAvailableGroupingsForAdd()[0])}
                className='bg-primary-main text-white'
                icon='add'
                priority='main'
                variant='outline'
                size='md'
              >
                Add grouping
              </SydButton>
            )}
          </div>
        )}
      </div>
      <div className='flex justify-start w-full gap-2'>
        <div className='flex items-center'>
          <SydButton onClick={resetGroupings} variant='outline'>
            <span className='font-size-sm font-bold p-2'>Reset Groupings</span>
          </SydButton>
        </div>
        <div className='flex items-center'>
          <SydButton onClick={onCancel} variant='outline'>
            <span className='font-size-sm font-bold p-2'>Cancel Changes</span>
          </SydButton>
        </div>
        <div className='flex items-center'>
          <SydButton
            onClick={() => {
              onGroupSave(activeGroupings)
              onCancel()
            }}
            variant='primary'
            priority='main'
          >
            <span className='font-size-sm font-bold p-2'>Save Changes</span>
          </SydButton>
        </div>
      </div>
    </div>
  )
}

GroupConfigurationContent.propTypes = {
  maxGroupings: PropTypes.number,
  availableGroupings: PropTypes.arrayOf(PropTypes.string),
  activeGroups: PropTypes.arrayOf(PropTypes.string),
  onGroupSave: PropTypes.func,
  onCancel: PropTypes.func,
  defaultGroups: PropTypes.arrayOf(PropTypes.string)
}

GroupConfigurationContent.defaultProps = {
  maxGroupings: 5,
  availableGroupings: [],
  activeGroups: [],
  onGroupSave: () => {},
  onCancel: () => {},
  defaultGroups: []
}

export default GroupConfigurationContent
